import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Rangos } from '@pages/fabrica-credito/interfaces/rangos';
import { Variables } from '@pages/fabrica-credito/interfaces/variables';
import { ExporterService } from '@shared/services/exporter/exporter.service';
import { RangosService } from '@pages/rangos/services/rangos.service';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { SwalService } from '@shared/utils/swal.service';
import { RangosFormComponent } from './rangos-form/rangos-form.component';

@Component({
  selector: 'app-rangos',
  templateUrl: './rangos.component.html',
  styleUrls: ['./rangos.component.css'],
})
export class RangosComponent implements OnInit {
  public columns: string[] = [
    'actions',
    'clavePerfil',
    'variable',
    'rango1',
    'rango2',
    'valorStr',
    'politica',
    'comentario',
    'siguiente',
    'score',
    'rango',
  ];
  clavePerfil: any;
  public allData: number = 0;
  public loading: boolean = true;
  constructor(
    private _exportService: ExporterService,
    private _rangosService: RangosService,
    public _dialog: MatDialog,
    private _dialogRef: MatDialogRef<RangosComponent>,
    private _swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.clavePerfil = JSON.parse(sessionStorage.getItem('clavePerfil'));
    this.read(this.clavePerfil);
  }

  private readonly _width: string = '900px';
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read(clavePerfil: string) {
    this._rangosService.read(clavePerfil).subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  openCreate() {
    const dialogRef = this._dialog.open(RangosFormComponent, {
      width: this._width
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read(this.clavePerfil);
    });
  }

  openUpdate(model: Variables) {
    const dialogRef = this._dialog.open(RangosFormComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read(this.clavePerfil);
    });
  }

  delete(model: Rangos) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._rangosService.delete(model).subscribe((res) => {
          if (res.exito === 1) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.read(this.clavePerfil);
        });
      }
    });
  }

  close() {
    this._dialogRef.close();
  }
  
}
